import { Separator } from '@/components/ui'

export function Testimonials() {
  return (
    <section className="max-w-2xl space-y-6 rounded-lg">
      <h2 className="text-fluid-h2 my-6">What Clients Say</h2>
      <blockquote className="text-muted italic">
        &quot;We diligently searched and interviewed prospective website designers, and they all lacked the expertise
        and understanding you hold in liturgy.&quot;
        <footer className="text-muted mt-2 text-sm not-italic">
          Susan Jane Matthews, DMA, Founding Coordinator, A Great Host of Composers
        </footer>
      </blockquote>
      <Separator />
      <blockquote className="text-muted italic">
        &quot;My experience working with Garrett was a pleasure from start to finish. He was organized, efficient and
        highly professional in helping to realize my vision for my website... Can&apos;t recommend him highly
        enough.&quot;
        <footer className="text-muted mt-2 text-sm not-italic">Matt Mueller, Baritone</footer>
      </blockquote>
      <Separator />
      <blockquote className="text-muted italic">
        &quot;I highly recommend enlisting Garrett&apos;s expertise to design (or redesign) your website... he creates a
        product even better than you could have imagined on your own.&quot;
        <footer className="text-muted mt-2 text-sm not-italic">Dr. Susan Bengtson, Violist &amp; Educator</footer>
      </blockquote>
      <Separator />
    </section>
  )
}
